import { render, staticRenderFns } from "./AwardGroupEditor.vue?vue&type=template&id=ef8c01f0&scoped=true&"
import script from "./AwardGroupEditor.vue?vue&type=script&setup=true&lang=js&"
export * from "./AwardGroupEditor.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AwardGroupEditor.vue?vue&type=style&index=0&id=ef8c01f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8c01f0",
  null
  
)

export default component.exports